export default "__VITE_ASSET__B1dq7E4d__"